import { useEffect } from 'react'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useDispatch, useSelector } from '@ufc/core'
import {
  KioskScanSection,
  selectScannedOrder,
} from '@ufc/domains/shipments'
import {
  queueActions,
  selectJoinError,
  selectJoinLoading,
  selectJoinResult,
} from '@ufc/domains/queue'
import {
  kioskConfigActions,
  selectIsPlantQueueClosed,
} from '@/store/kiosk-config.slice'

export const Route = createFileRoute('/scan')({
  component: ScanPage,
})

function ScanPage() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const scannedOrder = useSelector(selectScannedOrder)
  const joinLoading = useSelector(selectJoinLoading)
  const joinError = useSelector(selectJoinError)
  const joinResult = useSelector(selectJoinResult)

  const plantDocumentId = scannedOrder?.order.factory?.documentId ?? null
  const packaging = scannedOrder?.variant?.packaging ?? null
  const isQueueClosed = useSelector((state) =>
    selectIsPlantQueueClosed(
      state as Parameters<typeof selectIsPlantQueueClosed>[0],
      plantDocumentId,
      packaging,
    ),
  )

  const scannedOrderId = scannedOrder?.order.documentId ?? null

  useEffect(() => {
    dispatch(kioskConfigActions.fetchKioskConfig())
  }, [dispatch])

  useEffect(() => {
    dispatch(queueActions.clearJoinResult())
  }, [dispatch, scannedOrderId])

  return (
    <KioskScanSection
      onBack={() => navigate({ to: '/' })}
      onJoinQueue={(payload) => dispatch(queueActions.joinQueue(payload))}
      isJoiningQueue={joinLoading}
      joinError={joinError}
      joinResult={joinResult}
      isQueueClosed={isQueueClosed}
    />
  )
}

